/**
 * @generated SignedSource<<122501eeb489684526873ebdd6cdfec2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WebhookSubscriptionType = "DATADOG" | "FIREHYDRANT" | "INCIDENT_IO" | "OPSGENIE" | "PAGERDUTY" | "ROOTLY" | "SLACK" | "%future added value";
export type CreateOrUpdateWebhookSubscriptionInput = {
  webhookConfigs: ReadonlyArray<WebhookSubscriptionConfigInput>;
  webhookSubscriptionType: WebhookSubscriptionType;
};
export type WebhookSubscriptionConfigInput = {
  id?: any | null | undefined;
  name: string;
  opsgenieApiKey?: string | null | undefined;
  remoteId: string;
  secret: string;
};
export type OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables = {
  input: CreateOrUpdateWebhookSubscriptionInput;
};
export type OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation$data = {
  readonly createOrUpdateWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly webhookSubscriptions: ReadonlyArray<{
      readonly id: any;
      readonly name: string;
      readonly remoteId: string;
    }> | null | undefined;
  };
};
export type OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation = {
  response: OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation$data;
  variables: OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrUpdateWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "createOrUpdateWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLWebhookSubscription",
        "kind": "LinkedField",
        "name": "webhookSubscriptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "11023a4275f16a7aa4d661336b94fc0b",
    "id": null,
    "metadata": {},
    "name": "OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation OpsgenieIntegrationCreateOrUpdateWebhookSubscriptionMutation(\n  $input: CreateOrUpdateWebhookSubscriptionInput!\n) {\n  createOrUpdateWebhookSubscription(input: $input) {\n    webhookSubscriptions {\n      id\n      name\n      remoteId\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae997b63b0eecedbca35241caa70093b";

export default node;
